export function parseUserPermissions(permissionsRaw) {
  if (!permissionsRaw) return { view: [], edit: [] };
  try {
    const p = typeof permissionsRaw === 'string' ? JSON.parse(permissionsRaw) : permissionsRaw;
    return {
      view: Array.isArray(p.view) ? p.view : [],
      edit: Array.isArray(p.edit) ? p.edit : [],
    };
  } catch {
    return { view: [], edit: [] };
  }
}
